export const CAT_IN_SEG_QB_V2_FEATURE_FLAG = 'CatalogInSegmentationQueryBuilderV2';
